import { ProjectMember } from '../model/entities';
import adminApiAxios from './CustomAxios';

class AutomationApi {
    synchronizeProjectUserRoleServices = async (projectMembers: ProjectMember[], hubId: string): Promise<boolean> => {
        const body = projectMembers.map((pm) => ({ email: pm.email, projectId: pm.project?.id }));
        const response = await adminApiAxios.post<boolean>(
            '/automations/bim360/project-members/role-service-syncronizations',
            body,
            {
                params: { hubId },
            },
        );

        return response.data;
    };
}

const automationApi: AutomationApi = new AutomationApi();
export default automationApi;
